import React, { useState } from "react";
import PropTypes from "prop-types";
import styles from "./image-carousel.module.scss";
import { projectShape } from "../../modules/project";

const AngleRightIcon = props => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" {...props}>
        <path
            fill="currentColor"
            d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256S397.4 0 256 0zm102.6 278.6-112 112c-12.5 12.5-32.75 12.5-45.25 0s-12.5-32.75 0-45.25L290.8 256l-89.4-89.4c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l112 112C364.9 239.6 368 247.8 368 256s-3.1 16.4-9.4 22.6z"
        />
    </svg>
);

const AngleLeftIcon = props => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" {...props}>
        <path
            fill="currentColor"
            d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256S397.4 0 256 0zm54.6 345.4c12.5 12.5 12.5 32.75 0 45.25s-32.75 12.5-45.25 0l-112-112C147.1 272.4 144 264.2 144 256s3.125-16.38 9.375-22.62l112-112c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L221.3 256l89.3 89.4z"
        />
    </svg>
);

const ImageCarousel = ({ projectName, project }) => {
    const { images } = project;
    const hasImages = images && images.length > 0;
    const [showingIndex, setShowingIndex] = useState(0);
    const hasNextImage = !!images[showingIndex + 1];
    const hasPrevImage = !!images[showingIndex - 1];

    if (!hasImages) {
        return null;
    }

    const singleImage = images.length === 1;

    return (
        <div className={styles.carouselWrapper}>
            {!singleImage && (
                <button
                    title={
                        hasPrevImage
                            ? "Go to previous image."
                            : "Previous image. Button disabled."
                    }
                    className={`${styles.carouselButton} ${styles.prevButton} ${
                        hasPrevImage ? styles.active : styles.disabled
                    }`}
                    onClick={() => {
                        hasPrevImage && setShowingIndex(showingIndex - 1);
                    }}
                >
                    <AngleLeftIcon height={30} width={30} />
                </button>
            )}
            <img
                src={images[showingIndex].img}
                alt={images[showingIndex].alt}
                className={styles.singleImage}
                tabIndex={0}
            />
            {!singleImage && (
                <button
                    title={
                        hasNextImage
                            ? "Go to next image."
                            : "Next image. Button disabled."
                    }
                    className={`${styles.carouselButton} ${styles.nextButton} ${
                        hasNextImage ? styles.active : styles.disabled
                    }`}
                    onClick={() => {
                        hasNextImage && setShowingIndex(showingIndex + 1);
                    }}
                >
                    <AngleRightIcon height={30} width={30} />
                </button>
            )}
        </div>
    );
};

ImageCarousel.propTypes = {
    projectName: PropTypes.string,
    project: PropTypes.shape(projectShape),
};

export default ImageCarousel;



// WEBPACK FOOTER //
// ./src/components/image-carousel/ImageCarousel.js